import { Link, useLocation, useNavigate } from "react-router-dom";
import { useRef, useState } from 'react'
import logo from "../images/logo.svg";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { useLoginMutation } from "../redux/services/authApi";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../redux/features/authSlice";

export default function SignIn() {

    const [ email, setEmail ] = useState('')
    const [ password, setPassword ] = useState('')
    const [ keepLoggedIn, setKeepLoggedIn ] = useState(false)
    const [login, { isLoading }] = useLoginMutation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const toastId = useRef(null)

    const location = useLocation()
    const from = location.state?.from?.pathname || "/dashboard/"

    const authloading = () => toastId.current = toast(
        <><ClipLoader color="#636163" size={20} loading={true} /> Loading...</>, 
        { autoClose: false, position: toast.POSITION.TOP_RIGHT }
    )

    const authComplete = (response, isSuccess) => toast.update(toastId.current, {
        render:  isSuccess ? response?.message : response?.data?.message,
        type: isSuccess ? toast.TYPE.SUCCESS : toast.TYPE.ERROR,
        autoClose: 5000,
        position: toast.POSITION.TOP_RIGHT
    })
    
    let handleInput = (e) => {
        switch (e.target.id) {
            case 'email':
            setEmail(e.target.value);
            break;
            
            case 'password':
            setPassword(e.target.value);
            break;
            
            case 'keepLogged':
            setKeepLoggedIn(!keepLoggedIn);
            break;
            
            default:
            alert('sorry, unknown field');
            break;
        }
    }

    const submit = async (e) => {
        
        e.preventDefault()
        if (password === '' || email === '') {
            toast.error('All fields are required!', {
                position: toast.POSITION.TOP_RIGHT
            })
            return;
        }
        authloading()
        await login({ email, password })
            .unwrap()
            .then((payload) => {
                authComplete(payload, true)
                dispatch(loginSuccess({ user: payload.user, token: payload.token }))
                navigate(from, { replace: true })
            })
            .catch((error) => {
                authComplete(error, false)
                console.log('err', error)}
            )
    }


    return (
        <>
            <section className="row">
                <section className="col-md-6 p-md-3 px-md-5 pull-up">
                    <div className="w-75 mx-auto  my-md-0 my-4">
                        <div className="logo">
                            <img src={logo} alt="logo" />
                            <span className="logo-txt">Flash</span>
                        </div>
                        <div>
                            <h1 className="auth-title mb-4">Admin Login</h1>
                            <form onSubmit={submit}>
                                <div className="form-group mb-3">
                                    <label htmlFor="email" className="font-weight-bold mb-2">Email Address</label>
                                    <div className="input form-control border-secondary">
                                        <i className="ri-mail-line ri-lg px-2 w-25"></i> 
                                        <input type="email" onChange={handleInput} value={email} id="email" placeholder="Email Address" className="w-80 p-2 ps-0" />
                                    </div>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="password" className="font-weight-bold mb-2">Password</label>
                                    <div className="input form-control border-secondary">
                                        <i className="ri-lock-line ri-lg px-2 w-25"></i> 
                                        <input type="password" onChange={handleInput} value={password} id="password" placeholder="Password" className="w-80 p-2 ps-0" />
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className="col-lg-6">
                                        <label className="check-container">
                                            Keep me logged in
                                            <input type="checkbox" onClick={handleInput} value={keepLoggedIn} id="keepLogged" className="bg-flash check-input" />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="col-lg-6 text-lg-end">
                                        <Link to="/forgot-password" className="text-dark">Forgot password?</Link>
                                    </div>
                                </div>

                                <button className="submit-btn mt-3 p-3 form-control flash-bg text-uppercase fw-bold" onClick={submit}>
                                    { isLoading ? <ClipLoader size={20} /> : 'Login' }
                                </button>
                            </form>
                        </div>
                    </div>
                </section>
                <section className="col-md-6 px-0 d-none auth-side-img d-md-block"></section>
            </section>
        </>
    )
}